class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    const openDropdownBtn = this.querySelector('[data-open-dropdown]');
    const dropdownMenu = this.querySelector('[data-dropdown-menu]');
    const dropdownOptions = this.querySelectorAll('[data-dropdown-option]');
    const dropdownText = this.querySelector('[data-dropdown-text]');

    openDropdownBtn.addEventListener('click', () => {
      dropdownMenu.classList.toggle('hidden');
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        dropdownMenu.classList.add('hidden');
      }
    });

    dropdownOptions.forEach((option) => {
      option.addEventListener('click', (e) => {
        const li = option.closest('li');
        if (
          li &&
          (li.classList.contains('opacity-50') ||
            li.classList.contains('pointer-events-none') ||
            li.classList.contains('cursor-not-allowed') ||
            li.classList.contains('line-through'))
        ) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        // Update the main text
        const optionText = e.target.querySelector('span') || e.target;
        dropdownText.textContent = optionText.textContent;

        // Update price information if it exists
        const dropdownPrice = this.querySelector('[data-dropdown-price]');
        const dropdownStrikethroughPrice = this.querySelector('[data-dropdown-strikethrough-price]');
        const optionPrice = e.target.dataset.dropdownOptionPrice;

        if (dropdownPrice && optionPrice) {
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(optionPrice / 100);

          if (dropdownStrikethroughPrice) {
            dropdownStrikethroughPrice.textContent = formattedPrice;
          }
        }

        dropdownOptions.forEach((item) => {
          item.parentElement.classList.remove('bg-[#eee]');
          item.dataset.dropdownOption = '';
        });
        e.target.parentElement.classList.add('bg-[#eee]');
        e.target.dataset.dropdownOption = 'selected';
        dropdownMenu.classList.add('hidden');
      });
    });
  }
}

if (customElements.get('custom-dropdown-menu') === undefined) {
  customElements.define('custom-dropdown-menu', DropdownMenu);
}
